import { Component, OnInit } from '@angular/core';
import { LdsUserService } from '../../services/lds-user.service';

@Component({
    selector: 'ds-energy-monitor-list',
    templateUrl: './energy-monitor-list.component.html',
    styleUrls: ['./energy-monitor-list.component.scss'],
    standalone: false
})
export class EnergyMonitorListComponent implements OnInit{
  public groups;

  constructor(private user: LdsUserService) { 
  }

  ngOnInit(){
    const energyMonitors = this.user.energyMonitors;
    const keys = Object.keys(energyMonitors);
    this.groups = keys;
  }

}
